import React from "react";
import { useSearchParams } from "react-router-dom";
import "./PaymentStatus.css";

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get("payment_id");

  return (
    <div className="payment-status-container payment-success">
      <h2>✅ Pago Exitoso</h2>
      <p>¡Gracias por tu compra! Tu pago ha sido procesado correctamente.</p>
      <p><strong>ID de pago:</strong> {paymentId}</p>
      <a href="/">Volver al inicio</a>
    </div>
  );
};

export default SuccessPage;

